import {
  builderFragment,
  localeFragment,
} from './fragments.gql'

export default `query($locale: SiteLocale) {
  homepage (${localeFragment}) {
    ${builderFragment}
  }
}`
